


















































































































































































import { Vue, Component, Prop } from "vue-property-decorator";
import {
    Collapse, CollapseItem, Switch, Cell, CellGroup, Checkbox, CheckboxGroup, Popup, Loading, Field, Radio, RadioGroup, Picker, Calendar
} from "vant";
import moment from "moment";
import * as _ from "lodash";
import dataShare from "../dataShare";
import FlightOrder from "@/service/flightService";
import { ConsumerType } from "@/model/Base";
@Component({
    components: {
        [Collapse.name]: Collapse,
        [CollapseItem.name]: CollapseItem,
        [Switch.name]: Switch,
        [Checkbox.name]: Checkbox,
        [CheckboxGroup.name]: CheckboxGroup,
        [Cell.name]: Cell,
        [CellGroup.name]: CellGroup,
        [Popup.name]: Popup,
        [Picker.name]: Picker,
        [Loading.name]: Loading,
        [Radio.name]: Radio,
        [RadioGroup.name]: RadioGroup,
        [Field.name]: Field,
        [Calendar.name]: Calendar,
    },
})
export default class ExtendServices extends Vue {
    flightInfo = {
        ConsumerZoneCode: '',
        FinishedZoneCode: '',
        ConsumerDate: '',
        departCity: {
            ZoneName: "",
            ZoneCode: "",
        },
        arriveCity: {
            ZoneName: "",
            ZoneCode: "",
        },
        ConsumerCityCode: '',
        ConsumerCityName: '',
        FinishedCityCode: '',
        FinishedCityName: '',
        LevelID: '',
        arriveOptions: {
            disabledDate(time: any) {
                return time.getTime() < moment().add(-1, 'days');
            }
        },
    };
    Consumer = {
        Birthday: "",
        CardNo: "",
        CardOverDate: "",
        CardType: 1139,
        ConsumerData: "",
        ConsumerName: "",
        ConsumerSex: 1145,
        ContactEmail: "",
        ContactMobile: "",
        CountryCode: "",
        CountryID: "",
        CustomerID: "",
        EnglishFirstName: "",
        EnglishLastName: "",
        NotifyType: "",
        Notifys: [],
        inputFlag: '',
    };
    model = {
        AdultCount: 1,
        ChildCount: 1,
        InfantCount: 1,
        Policys: [{
            Products: []
        }] as any[],
        PassageType: 'Normal',
        flightInfos: [],
        ConsumerTypes: [],
        ApplyArea: 1127,
        BookingType: 1529,
        BookingUserID: "",
        BookingUserName: "",
        CenterID: "",
        CompanyID: "",
        CompanyName: "",
        Contrarys: [],
        CreateUserID: "",
        Extras: [],
        FlowID: "",
        PolicyID: "",
        ProduceID: "",
        ProductID: "",
        ProjectCode: "",
        RoomNum: "",
        ServiceType: 1409,
        SupplyID: "",
        SupplyName: "",
        TripIntent: "",
        LevelID: 1496,
        ProductName: '',
        ConsumerCityName: '',
        ConsumerCityCode: '',
        ReceiveTradeAmount: 600,
        ProduceLevel: 3,
        ProduceName: '',
        DepartureDate: '',
        ArrivalDate: '',
        DepartDate: moment().add(1, 'days').format('YYYY-MM-DD'),
        ArriveDate: moment().add(2, 'days').format('YYYY-MM-DD'),
        ConsumersNum: 1,
        Remark: '',
        departCity: {
            ZoneName: "上海",
            ZoneCode: "SHH",
            CountryID: 151
        },
        ContactEmail: "",
        ContactName: "",
        ContactPhone: "",
        Consumers: [] as any[],
    };
    data = {
        showDate: false,
        Product: {} as any,
        dataShare: dataShare,
        models: { contactTel: '400-088-8020' },
        loading: false,
        maxDate: moment('2050-01-01').toDate()
    };
    LimitPassageTypes: { label: string, value: string }[] = [
    ];
    Cabins = [
        { "CategoryID": 1496, "CategoryTitle": "经济舱", "CategoryCode": "Economy" },
        { "CategoryID": 1498, "CategoryTitle": "商务舱", "CategoryCode": "Buissenes" },
        { "CategoryID": 1500, "CategoryTitle": "头等舱", "CategoryCode": "First" },
    ];
    ProduceCode = '';
    // 计算属性
    get ServiceType() {
        return _.upperFirst(this.$route.query?.serviceCode + 'Service')
    }

    get City(): any {
        return this.data.dataShare.City;
    }
    set City(value: any) {
        this.data.dataShare.City = value;
    }


    //activated
    activated() {
        if (this.selectCode && this.City && this.City.value) {
            let City = this.City;
            if (this.selectCode == "DepartCity") {
                this.data.Product.departCity.ZoneName = City.label;
                this.data.Product.departCity.ZoneCode = City.value;
                this.data.Product.ConsumerZoneCode = City.value;
                this.data.Product.ConsumerZoneName = City.label;
                this.data.Product.departCity.CountryID = City.CountryID;
            } else if (this.selectCode == "ArriveCity") {
                this.data.Product.arriveCity.ZoneName = City.label;
                this.data.Product.arriveCity.ZoneCode = City.value;
                this.data.Product.arriveCity.CountryID = City.CountryID;
                this.data.Product.FinishedZoneCode = City.value;
                this.data.Product.FinishedZoneName = City.label;
            }
        }
    }
    // created
    created() {
        // let __self: any = this;
        // __self.$api.base.gettripcom({}).then(json => {
        //     if (json.data.isSucc) {
        //         __self.data.models = json.data.result;
        //     }
        // })
    }
    // mounted
    mounted() {
        this.initFlight()
        this.initLimits()
    }
    // 初始化Limits
    initLimits() {
        const arr = [
            {
                label: this.$t('mall.normal') as string,
                value: 'Normal',
            },
            {
                label: this.$t('mall.student') as string,
                value: 'OverseasStudent',
            }, {
                label: this.$t('mall.newimmigrant') as string,
                value: 'Immigrant',
            },
            {
                label: this.$t('mall.worker') as string,
                value: 'Worker',
            }
        ]
        this.LimitPassageTypes = arr
    }
    // 日期格式化
    resetConsumerDate(date: string) {
        return moment(date).format('YYYY-MM-DD')
    }
    // 初始化航程数组
    initFlight() {
        let __self = this;
        // 确保 Policys 已初始化
        if (!__self.model?.Policys) {
            __self.model.Policys = [{ Products: [] }];
        }
        for (let i = 0; i < __self.model.Policys.length; i++) {
            let Products: any = __self.model.Policys[i].Products;
            for (let j = 0; j < 2; j++) {
                let CloneFlightInfo = _.cloneDeep(__self.flightInfo)
                Products.push(CloneFlightInfo);
                if (j > 0) {
                    let time = new Date();
                    CloneFlightInfo.arriveOptions.disabledDate = function (time) {
                        return time.getTime() < Products[j - 1].ConsumerDate;
                    }
                }
            }
        }
    }
    // 删除航程
    delFlight(index: number) {
        let __self = this;
        for (let i = 0; i < __self.model.Policys.length; i++) {
            let Products = __self.model.Policys[i].Products;
            Products.splice(index, 1);
        }
    }
    // 添加航程
    addFlight() {
        let __self = this;
        for (let i = 0; i < __self.model.Policys.length; i++) {
            let Products: any = __self.model.Policys[i].Products;
            let CloneFlightInfo = _.cloneDeep(__self.flightInfo)
            Products.push(CloneFlightInfo);
            let time = new Date();
            Products[Products.length - 1].arriveOptions.disabledDate = function (time: any) {
                return time.getTime() < Products[Products.length - 2].ConsumerDate;
            }
        }
    }
    selectDate(Product: any) {
        this.data.Product = Product
        this.data.showDate = true;
    }
    // 航程日期选择
    onConfirm(date: any) {
        this.data.showDate = false;
        this.data.Product.ConsumerDate = moment(date).format('YYYY-MM-DD 00:00:00');
    }
    // 航程出发到达选择
    selectCode = "";
    selectCity(cityType: string, Product: any) {
        this.City = null;
        this.selectCode = cityType;
        this.data.Product = Product
        this.$router.push({
            path: "/selectAirport",
            query: {
                ServiceType: 'FlightService',
                ApplyArea: '1127',
            },
        });
    }
    Save() {
        let __self = this;
        let $utils = this.$root.$toast
        __self.model.Consumers = [];
        if (__self.ServiceType == "HotelService") {
            if (__self.model.ProduceName == '') {
                return $utils.fail('酒店名称不能为空');
            }
            if (__self.model.ContactPhone == '') {
                return $utils.fail('联系电话不能为空');
            }
            let RegExps = /^1\d{10}$/
            if (!RegExps.test(__self.model.ContactPhone)) {
                return $utils.fail('请输入正确的联系电话');
            }
            for (let i = 0; i < __self.model.ConsumersNum; i++) {
                __self.model.Consumers.push(__self.Consumer)
            }
            __self.model.ConsumerCityName = __self.model.departCity.ZoneName;
            __self.model.ConsumerCityCode = __self.model.departCity.ZoneCode;
            __self.model.DepartureDate = __self.model.ArriveDate;
            __self.model.ArrivalDate = __self.model.DepartDate;

        }
        if (__self.ServiceType == "FlightService") {
            if (__self.model.ContactPhone == '') {
                return $utils.fail('联系电话不能为空');
            }
            let RegExps = /^1\d{10}$/
            if (!RegExps.test(__self.model.ContactPhone)) {
                return $utils.fail('请输入正确的联系电话');
            }
            if (__self.model.AdultCount > 0) {
                for (let i = 0; i < __self.model.AdultCount; i++) {
                    __self.model.Consumers.push({
                        ConsumerType: ConsumerType.Young
                    });
                }
            }
            if (__self.model.ChildCount > 0) {
                for (let i = 0; i < __self.model.ChildCount; i++) {
                    __self.model.Consumers.push({
                        ConsumerType: ConsumerType.Enfant
                    });
                }
            }
            if (__self.model.InfantCount > 0) {
                for (let i = 0; i < __self.model.InfantCount; i++) {
                    __self.model.Consumers.push({
                        ConsumerType: ConsumerType.Infant
                    });
                }
            }
            __self.model.Remark = __self.model.Remark + "&" + __self.model.PassageType;
            __self.model.Policys.forEach(o => {
                o.Products.forEach((m: any) => {
                    m.ConsumerZoneCode = m.departCity.ZoneCode;
                    m.FinishedZoneCode = m.arriveCity.ZoneCode;
                    m.ConsumerZoneName = m.departCity.ZoneName;
                    m.FinishedZoneName = m.arriveCity.ZoneName;
                    m.LevelID = __self.model.LevelID + '';
                    let Cabin = _.find(__self.Cabins, k => k.CategoryID == __self.model.LevelID)
                    if (Cabin) {
                        m.LevelName = Cabin.CategoryTitle;
                    }
                    m.ProduceCode = __self.ProduceCode
                })
            });
        }
        __self.data.loading = true
        FlightOrder.CreateOrderByPreference(__self.model).then(res => {
            __self.data.loading = false
            if (res.isSucc) {
                $utils.success('需求提交成功');
                __self.$router.push({
                    path: '/order/list'
                })
            } else {
                $utils.fail(res.message);
            }
        }).catch(() => {
            __self.data.loading = false
        })
    }

}
